import React, { Component } from "react";
import { connect } from "react-redux";
import ReportGeneralTable from "./ReportGeneralTable";
import ReportStore from "../../stores/ReportStore";
import FontAwesome from "react-fontawesome";
import { Checkbox } from "react-icheck";
import { Popover, OverlayTrigger, Tabs, Tab } from "react-bootstrap";
import { momentHelper } from "./helpers";
import ConfirmPopup from "../../component/element/ConfirmPopup";
import IframeModal from "../../component/element/IframeModal";
import JSWorkDocViewModal from "view/workdoc/JSWorkdocViewModal";

var NotificationSystem = require("react-notification-system");
const cHeaderTitles = [
  { title: "", width: "50px", checkAll: true },
  { title: "วันที่ออก", width: "100px" },
  { title: "ใบแจ้งหนี้", width: "120px" },
  { title: "ใบเสร็จ", width: "120px" },
  { title: "ใบงานเลขที่", width: "220px" },
  { title: "ทะเบียนรถ", width: "150px" },
  { title: "ยี่ห้อ", width: "150px" },
  { title: "รุ่น", width: "150px" },
  { title: "กม.", width: "80px" },
  { title: "ชื่อลูกค้า", width: "200px" },
  { title: "ครบกำหนด", width: "100px" },
  { title: "มูลค่า(บาท)", width: "100px" },
  { title: "สถานะ", width: "100px" },
];
const cHeaderTitlesCompany = [
  { title: "", width: "50px", checkAll: true },
  { title: "วันที่ออก", width: "100px" },
  { title: "ออกโดย", width: "100px" },
  { title: "ใบแจ้งหนี้", width: "120px" },
  { title: "ใบเสร็จ", width: "120px" },
  { title: "ใบงานเลขที่", width: "220px" },
  { title: "ทะเบียนรถ", width: "150px" },
  { title: "ยี่ห้อ", width: "150px" },
  { title: "รุ่น", width: "150px" },
  { title: "กม.", width: "80px" },
  { title: "ชื่อลูกค้า", width: "200px" },
  { title: "ครบกำหนด", width: "100px" },
  { title: "มูลค่า(บาท)", width: "100px" },
  { title: "สถานะ", width: "100px" },
  { title: "หมายเหตุ", width: "100px", keyField: "remark" },
];

const viewModeList = ["all", "unpaid", "paid", "cancel"];
class ReportInvoicePage extends Component {
  constructor(...args) {
    super(...args);
    const month = momentHelper.getMonth();
    const year = momentHelper.getYear();
    const searchBy = "invoice_no";
    const query = "";
    this.state = {
      showTable: true,
      showGenDoc: false,
      data: [],
      companylist: [],
      activeKey: 1,
      month: month,
      year: year,
      day: "00",
      searchBy: searchBy,
      query: query,
      start: 0,
      activePage: 0,
      itemPerPage: 13,
      check: [],
      headerTitles: cHeaderTitles,
      isCheckAll: false,
      showSelectMenu: false,
      showClose: false,
      loadClose: false,
      isDocClose: false,
      pdf_template: {
        PrintBillingNoteCompany: "PrintKKCBillingNoteCompany",
        PrintBillingNoteInsurer: "PrintSSTBillingNoteInsurer",
      },
    };
    this.refTable = [null, null, null, null];
  }

  onRowSelect(item) {
    if (!item.readonly) {
      this.setState({ showTable: false });

      if (this.props.onDocShow !== undefined) {
        this.props.onDocShow(item.doc_no);
      }
      window.show_invoice_doc(item.doc_no, () => {
        this.setState({ showTable: true });
      });
    } else {
      this.refs.notificationSystem.addNotification({
        title: "แจ้งเตือน",
        message: "ไม่สามารถเปิดดูได้",
        level: "error",
        position: "tc",
      });
    }
  }

  onGenDocClose() {
    this.setState({ isDocClose: true }, () => {
      this.showTable();
    });
  }

  showTable() {
    this.setState({
      showGenDoc: false,
      showTable: true,
      doc_no: "",
      showClose: true,
      loadClose: true,
    });
    if (this.props.onTableShow !== undefined) {
      this.props.onTableShow();
    }
  }

  loadData(
    year,
    month,
    day,
    searchBy,
    query,
    activePage,
    itemPerPage,
    is_check,
    callback
  ) {
    let { activeKey } = this.state;
    ReportStore.loadInvoiceList(
      viewModeList[activeKey - 1],
      year,
      month,
      day,
      searchBy,
      query,
      activePage * itemPerPage,
      itemPerPage,
      (result) => {
        this.processData(result, is_check);
        this.setState({
          activePage: activePage,
          start: activePage * itemPerPage,
        });
        callback(result);
      }
    );
  }

  loadDataRange(
    start,
    end,
    searchBy,
    query,
    activePage,
    itemPerPage,
    is_check,
    callback
  ) {
    let { activeKey } = this.state;

    ReportStore.loadInvoiceListRange(
      viewModeList[activeKey - 1],
      start,
      end,
      searchBy,
      query,
      activePage * itemPerPage,
      itemPerPage,
      (result) => {
        this.processData(result, is_check);
        this.setState({
          activePage: activePage,
          start: activePage * itemPerPage,
        });
        callback(result);
      }
    );
  }

  processData(result, is_check = false) {
    let { headerTitles, pdf_template, check } = this.state;
    result.data = result.data.map((item, index) => {
      item = Object.assign({ check: false }, item);
      return item;
    });
    if (result.companylist.length > 1) {
      headerTitles = cHeaderTitlesCompany;
    }
    pdf_template = Object.assign(pdf_template, result.pdf_template);
    this.setState({
      showSelectMenu: false,
      isCheckAll: false,
      pdf_template: pdf_template,
      companylist: result.companylist,
      headerTitles: headerTitles,
      data: result.data,
      check: new Array(result.data.length).fill(false),
    });
  }

  renderStatus(status, row) {
    let result = <span></span>;

    if (row.work_status === "0") {
      result = (
        <span className="label label-default" data-value="0">
          <FontAwesome name="clock-o" /> เริ่มต้น
        </span>
      );
    } else if (row.work_status === "1") {
      result = (
        <span className="label label-warning" data-value="1">
          <FontAwesome name="wrench" /> อยู่ระหว่างซ่อม
        </span>
      );
    } else if (row.work_status === "2") {
      result = (
        <span className="label label-primary" data-value="2">
          <FontAwesome name="hourglass-start" /> รอส่งมอบรถ
        </span>
      );
    } else if (row.work_status === "3") {
      result = (
        <span className="label label-success" data-value="3">
          <FontAwesome name="thumbs-o-up" /> ปิดจบงาน
        </span>
      );
    } else if (row.work_status === "5") {
      result = (
        <span className="label label-purple" data-value="5">
          <FontAwesome name="bitcoin" /> ตั้งเบิก
        </span>
      );
    } else {
      result = <span></span>;
    }

    if (row.doc_status !== undefined && row.doc_status * 1 === 2) {
      result = (
        <div>
          {result}
          <span className="label label-success">
            <FontAwesome name="money" /> ชำระเงินแล้ว
          </span>
        </div>
      );
    }
    if (row.doc_cancel !== undefined && row.doc_cancel * 1 === 1) {
      result = (
        <div>
          {result}
          <span className="label label-danger">
            <FontAwesome name="trash" /> ยกเลิก
          </span>
        </div>
      );
    }

    if (row.doc_cancel_remark !== undefined && row.doc_cancel_remark !== "") {
      result = (
        <div>
          {result}
          <span className="label label-danger">
            <FontAwesome name="trash" /> {row.doc_cancel_remark}
          </span>
        </div>
      );
    }

    return result;
  }

  renderWorkNo(data, row) {
    if (data !== "" && data !== null) {
      let title = "ใบงานซ่อม " + data;
      let popoverHoverFocus = (
        <Popover id="popover-trigger-hover-focus" title={title}>
          <strong>คลิกตรงไอค่อนเพื่อเข้าดูใบงาน</strong>
        </Popover>
      );

      return (
        <span>
          {data}{" "}
          <OverlayTrigger
            trigger={["hover", "focus"]}
            placement="right"
            overlay={popoverHoverFocus}
          >
            <FontAwesome
              onClick={this.onIconClick.bind(this, data)}
              className="text-blue"
              name="file-text-o"
            />
          </OverlayTrigger>
        </span>
      );
    } else {
      return <span>{data}</span>;
    }
  }

  onIconClick(workNo, e) {
    this.refs.jsWork.loadData(workNo);
  }

  onCheckChange(rowIndex) {
    let { showSelectMenu, check, isCheckAll, data } = this.state;
    check[rowIndex] = !check[rowIndex];
    data[rowIndex].check = !data[rowIndex].check;
    showSelectMenu = false;
    let key = check.findIndex((x) => x !== false);
    if (key !== -1) showSelectMenu = true;

    isCheckAll = this.checkAll(check);
    this.setState({
      check: check,
      showSelectMenu: showSelectMenu,
      isCheckAll: isCheckAll,
      data: data,
    });
  }

  checkAll(check) {
    let { data } = this.state;
    let isCheckAll = true;
    check.forEach((item, index) => {
      if (data[index]) {
        if (!item && data[index].work_status !== "3") isCheckAll = false;
      }
    });
    return isCheckAll;
  }

  validateSameCustomer(newItem, checkItems) {
    let valid = true;
    checkItems.map((item, index) => {
      if (item.customer_name !== newItem.customer_name) {
        valid = false;
      }
      return item;
    });

    return valid;
  }

  onMenuClick(eventKey) {
    let { check, data } = this.state;
    let ind = 0;
    let checkItems = data.reduce((rresult, item) => {
      if (check[ind]) {
        rresult.push(item);
      }
      ind++;
      return rresult;
    }, []);

    let isValide = this.validBeforePrint(checkItems);
    if (isValide) {
      if (eventKey === "taxinvoice") {
        if (window.create_new_taxinvoice_from_invoice !== undefined) {
          this.setState({ showTable: false });
          window.create_new_taxinvoice_from_invoice(checkItems, () => {
            //Work Callback
          });
        }
      } else if (eventKey === "cashbill") {
        if (window.create_new_cashbill_from_invoice !== undefined) {
          this.setState({ showTable: false });
          window.create_new_cashbill_from_invoice(checkItems, () => {
            //Work Callback
          });
        }
      }
    } else {
      this.setState({ showSelectEror: true });
    }
  }

  validBeforePrint(_data) {
    let customer_name = [];
    _data.forEach((item, index) => {
      if (item) {
        if (customer_name.indexOf(item.customer_name) === -1)
          customer_name.push(item.customer_name);
      }
    });

    return customer_name.length > 1 ? false : true;
  }

  onPrintBillingClick(e) {
    let { check, data } = this.state;
    let isValideCustomer = this.validBeforePrint(check);
    if (isValideCustomer) {
      let { check, pdf_template } = this.state;
      let _item = {};
      let doc_nos = [];
      check.forEach(function (item, index) {
        if (item !== false) {
          _item = data[index];
          doc_nos.push(data[index].doc_no);
        }
      });
      let doc_no = doc_nos.join();
      let url = "";
      if (_item.insurer_id > 0) {
        if (process.env.NODE_ENV === "development") {
          url =
            "./?startPage=" +
            pdf_template.PrintBillingNoteInsurer +
            "&ivlist=" +
            doc_no;
        } else {
          url =
            "./pdf/v2/?startPage=" +
            pdf_template.PrintBillingNoteInsurer +
            "&ivlist=" +
            doc_no;
        }
      } else {
        if (process.env.NODE_ENV === "development") {
          url =
            "./?startPage=" +
            pdf_template.PrintBillingNoteCompany +
            "&ivlist=" +
            doc_no;
        } else {
          url =
            "./pdf/v2/?startPage=" +
            pdf_template.PrintBillingNoteCompany +
            "&ivlist=" +
            doc_no;
        }
      }
      this.refs.iframe.loadUrl(url);
    } else {
      this.setState({ showSelectEror: true });
    }
  }

  onPrintShippingLabelClick(e) {
    let { check, data } = this.state;
    let doc_nos = [];
    check.forEach(function (item, index) {
      if (item !== false) {
        doc_nos.push(data[index].doc_no);
      }
    });
    let doc_no = doc_nos.join();
    let url = "";
    if (process.env.NODE_ENV === "development") {
      url = "./?startPage=PrintShippingLabel&idlist=" + doc_no + "&doc=invoice";
    } else {
      url =
        "./pdf/v2/?startPage=PrintShippingLabel&idlist=" +
        doc_no +
        "&doc=invoice";
    }
    this.refs.iframe.loadUrl(url);
  }

  onPayIconClick(row) {
    if (typeof window.show_taxinvoice_doc !== "undefined")
      window.show_taxinvoice_doc(row.pay_taxinvoice_no);
  }

  onRenderColumn(data, col, row, rowIndex) {
    let { check, activePage, start } = this.state;
    let { companylist } = this.state;
    let index = companylist.length > 1 ? 1 : 0;

    if (col === 0) {
      return (
        <Checkbox
          onChange={this.onCheckChange.bind(this, rowIndex)}
          checked={check[rowIndex] !== false ? true : false}
          checkboxClass="icheckbox_square-blue"
          increaseArea="20%"
          label=""
          disabled={row.work_status === "3" ? true : false}
        />
      );
    } else if (col === 12 + index) {
      return this.renderStatus(data, row);
    } else if (col === 4 + index) {
      data = row.work_no;
      if (data !== "") {
        let title = "ใบงานซ่อม " + data;
        let popoverHoverFocus = (
          <Popover id="popover-trigger-hover-focus" title={title}>
            <strong>คลิกตรงไอค่อนเพื่อเข้าดูใบงาน</strong>
          </Popover>
        );

        return (
          <span>
            {data}{" "}
            <OverlayTrigger
              trigger={["hover", "focus"]}
              placement="right"
              overlay={popoverHoverFocus}
            >
              <FontAwesome
                onClick={this.onIconClick.bind(this, data)}
                className="text-blue"
                name="file-text-o"
              />
            </OverlayTrigger>
          </span>
        );
      }
    } else if (col === 3 + index) {
      if (
        data !== "" &&
        row.bill_taxinvoice_no !== undefined &&
        row.bill_taxinvoice_no !== ""
      ) {
        let bill_text = "ใบเสร็จรับเงิน/กำกับภาษี";
        if (row.pay_cashbill_no !== "") {
          bill_text = "บิลเงินสด";
        }
        let title = "มี" + bill_text + "เลขที่ " + row.bill_taxinvoice_no;
        let popoverHoverFocus = (
          <Popover id="popover-trigger-hover-focus" title={title}>
            <strong>คลิกตรงไอค่อนเพื่อเข้าดู{bill_text}</strong>
          </Popover>
        );

        return (
          <span>
            {data}
            <OverlayTrigger
              trigger={["hover", "focus"]}
              placement="right"
              overlay={popoverHoverFocus}
            >
              <FontAwesome
                onClick={this.onPayIconClick.bind(this, row)}
                className="text-green"
                name="file-text-o"
              />
            </OverlayTrigger>
          </span>
        );
      } else {
        return <span>{data}</span>;
      }
    } else {
      return <span>{data}</span>;
    }
  }

  onTabsSelect(e) {
    this.setState({ isDocClose: false }, () => {
      this.setState({ activeKey: e }, () => {
        this.refTable[e - 1].refreshTable();
      });
    });
  }

  onCheckAll() {
    let { data, isCheckAll, check } = this.state;
    if (data.length === 0) return false;

    if (!isCheckAll) {
      let newCheck = check.map((item, index) => {
        if (data[index].work_status === "3") return false;
        else return true;
      });

      this.setState({
        isCheckAll: true,
        check: newCheck,
        showSelectMenu: true,
      });
    } else {
      let newCheck = check.map((item, index) => {
        item = false;
        return item;
      });
      this.setState({
        isCheckAll: false,
        check: newCheck,
        showSelectMenu: false,
      });
    }
  }

  onRenderCheckAll(key, index) {
    return (
      <th
        key={key + "-" + index}
        className={"text-center"}
        style={{ width: "50px", maxWidth: "50px" }}
      >
        <Checkbox
          onChange={this.onCheckAll.bind(this)}
          checked={this.state.isCheckAll}
          checkboxClass="icheckbox_square-blue"
          increaseArea="20%"
          label=""
        ></Checkbox>
      </th>
    );
  }

  onTypePrintSelect(key) {
    if (key === 0) {
      this.onPrintBillingClick();
    } else if (key === 1) {
      this.onPrintShippingLabelClick();
    }
  }

  render() {
    let {
      isDocClose,
      showTable,
      activeKey,
      showSelectMenu,
      showSelectEror,
      headerTitles,
    } = this.state;

    const searchOptions = [
      {
        label: "เลขที่ใบแจ้งหนี้",
        value: "invoice_no",
      },
      {
        label: "ใบงานเลขที่",
        value: "work_no",
      },
      {
        label: "ทะเบียนรถ",
        value: "car_registration_no",
      },
      {
        label: "ลูกค้า/เจ้าของรถ",
        value: "customer_name",
      },
      {
        label: "บริษัทประกัน",
        value: "insurance_name",
      },
    ];
    let menuTitle = (
      <span>
        <FontAwesome name="pencil" /> สร้างใบเสร็จ
      </span>
    );
    const menuOption = [
      {
        eventKey: "taxinvoice",
        icon: "file-text-o",
        className: "text-green",
        title: "ใบเสร็จรับเงิน/ใบกำกับ",
      },
      {
        eventKey: "cashbill",
        icon: "file-text-o",
        className: "text-green",
        title: "บิลเงินสด",
      },
    ];

    const tabsList = [
      {
        key: "all",
        title: (
          <div>
            <FontAwesome name="files-o" /> ทั้งหมด
          </div>
        ),
        loadOnShow: true,
      },
      {
        key: "unpaid",
        title: (
          <div>
            <FontAwesome name="money" /> รอเก็บเงิน
          </div>
        ),
        loadOnShow: true,
      },
      {
        key: "paid",
        title: (
          <div>
            <FontAwesome name="thumbs-o-up" /> ได้รับเงินเรียบร้อย
          </div>
        ),
        loadOnShow: true,
      },
      {
        key: "cancel",
        title: (
          <div>
            <FontAwesome name="trash" /> ยกเลิก
          </div>
        ),
        loadOnShow: true,
      },
    ];
    const style = {
      NotificationItem: {
        // Override the notification item
        DefaultStyle: {
          // Applied to every notification, regardless of the notification level
          margin: "10px 5px 2px 1px",
          fontSize: "30px",
          width: "400px",
          textAlign: "center",
        },
      },
    };
    return (
      <div>
        <Tabs
          activeKey={activeKey}
          id="tabs-report-invoice-page"
          onSelect={this.onTabsSelect.bind(this)}
        >
          {tabsList.map((item, index) => (
            <Tab key={index} eventKey={index + 1} title={item.title}>
              <div style={{ display: showTable ? "block" : "none" }}>
                <ReportGeneralTable
                  ref={"ivTable"}
                  onRef={(ref) => {
                    this.refTable[index] = ref;
                  }}
                  title="ใบแจ้งหนี้"
                  newTitle="เพิ่มรายการ"
                  selectMenuTitle={menuTitle}
                  selectMenuOption={menuOption}
                  printTitle="พิมพ์เอกสาร"
                  showNewButton={false}
                  showPrintButton={true}
                  showSelectMenu={showSelectMenu}
                  showCreate={true}
                  headerTitles={headerTitles}
                  excludeColumn={[
                    "status_html",
                    "doc_no",
                    "pay_taxinvoice_no",
                    "pay_cashbill_no",
                    "insurer_id",
                    "doc_status",
                    "readonly",
                    "doc_cancel_remark",
                    "doc_cancel",
                  ]}
                  excludeClickColumn={["work_no", "bill_taxinvoice_no"]}
                  searchOptions={searchOptions}
                  searchBy={"invoice_no"}
                  loadData={this.loadData.bind(this)}
                  loadDataRange={this.loadDataRange.bind(this)}
                  onRenderCheckAll={this.onRenderCheckAll.bind(
                    this,
                    item.key,
                    index
                  )}
                  onRenderColumn={this.onRenderColumn.bind(this)}
                  onRowSelect={this.onRowSelect.bind(this)}
                  onMenuClick={this.onMenuClick.bind(this)}
                  onPrintClick={this.onPrintBillingClick.bind(this)}
                  onTypePrintSelect={this.onTypePrintSelect.bind(this)}
                  docType={"invoice"}
                  viewMode={viewModeList[activeKey - 1]}
                  minWidth={1300}
                  isMobile={this.props.isMobile}
                  mobileFieldMap={{
                    title: "customer_name",
                    amount: "amount",
                    sub_title: "bill_no",
                    date: "doc_date",
                    status: "work_status",
                    sub_status: "",
                  }}
                  renderWorkStatus={this.renderStatus.bind(this)}
                  btnTitlePrint={"พิมพ์ตาราง"}
                  show={
                    isDocClose
                      ? activeKey === index + 1
                        ? this.state.showClose
                        : false
                      : this.state.showClose
                  }
                  loadOnShow={
                    isDocClose
                      ? activeKey === index + 1
                        ? this.state.loadClose
                        : false
                      : this.state.loadClose
                  }
                  callOut={activeKey === index + 1 ? false : true}
                  defaultMonth={"00"}
                  defaultDay={"00"}
                />
              </div>
            </Tab>
          ))}
        </Tabs>

        <ConfirmPopup
          show={showSelectEror}
          title="เกิดข้อผิดพลาด"
          confirmTitle="ทำการเลือกใหม่"
          cancelTitle="ยกเลิก"
          message="กรุณาเลือกชื่อลูกค้าหรือประกันเดียวกัน โปรดลองใหม่"
          onConfirm={() => {
            this.setState({ showSelectEror: false });
          }}
          onHide={() => {
            this.setState({ showSelectEror: false });
          }}
        />
        <div style={{ display: !showTable ? "block" : "none" }}></div>
        <IframeModal ref="iframe" title={"พิมพ์ตาราง"} />
        <NotificationSystem ref="notificationSystem" style={style} />
        <JSWorkDocViewModal
          ref="jsWork"
          title={"แสดงผลใบงาน "}
          modal={true}
          fullScreen={true}
        />
      </div>
    );
  }
}

export default ReportInvoicePage = connect(
  (state) => ({ messages: state.message.view.report.ReportInvoicePage }),
  null,
  null,
  { withRef: true }
)(ReportInvoicePage);



// WEBPACK FOOTER //
// ./src/view/report/ReportInvoicePage.js